/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Roadmap_TitleInputs */

const en_us2_community_roadmap_title = /** @type {(inputs: Community_Roadmap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming next`)
};

const pt_br2_community_roadmap_title = /** @type {(inputs: Community_Roadmap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que vem por aí`)
};

const es_419_community_roadmap_title = /** @type {(inputs: Community_Roadmap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo que viene`)
};

const pt_pt2_community_roadmap_title = /** @type {(inputs: Community_Roadmap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que aí vem`)
};

const fr_fr2_community_roadmap_title = /** @type {(inputs: Community_Roadmap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À venir`)
};

const de_de2_community_roadmap_title = /** @type {(inputs: Community_Roadmap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demnächst`)
};

const it_it2_community_roadmap_title = /** @type {(inputs: Community_Roadmap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In arrivo`)
};

/**
* | output |
* | --- |
* | "Coming next" |
*
* @param {Community_Roadmap_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_roadmap_title = /** @type {((inputs?: Community_Roadmap_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Roadmap_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_roadmap_title(inputs)
	if (locale === "es-419") return es_419_community_roadmap_title(inputs)
	if (locale === "pt-PT") return pt_pt2_community_roadmap_title(inputs)
	if (locale === "fr-FR") return fr_fr2_community_roadmap_title(inputs)
	if (locale === "de-DE") return de_de2_community_roadmap_title(inputs)
	if (locale === "it-IT") return it_it2_community_roadmap_title(inputs)
	return en_us2_community_roadmap_title(inputs)
});
export { community_roadmap_title as "community.roadmap_title" }